import axios from "axios";
import {
  BackendModule,
  InitOptions,
  ReadCallback,
  Services,
  TOptions,
} from "i18next";
import { chunkArray } from "../utils/arrayUtils";

const MAX_REQUEST_LABELS_COUNT = 50;

class ContentApiBackend implements BackendModule {
  apiKey: string = "";
  apiUrl: string = "";
  labels: string[] = [];
  type: "backend" = "backend";

  init(
    services: Services,
    backendOptions: TOptions,
    i18nextOptions: InitOptions
  ) {
    this.apiKey = backendOptions.apiKey;
    this.apiUrl = `${backendOptions.apiUrl}/api/v2/labels`;
    this.labels = backendOptions.labels;
  }

  async read(language: string, namespace: string, callback: ReadCallback) {
    const baseUrl = `${
      this.apiUrl
    }/${namespace.toLowerCase()}/${language.toLowerCase()}`;
    const promises = chunkArray(this.labels, MAX_REQUEST_LABELS_COUNT).map(
      (labels) => fetchLabel(baseUrl, this.apiKey, labels.toString())
    );
    const labelsResults = await Promise.all(promises);
    const fetchedLabels = labelsResults.reduce(
      (acc, labels) => ({ ...acc, ...labels }),
      {}
    );
    callback(null, fetchedLabels);
  }

  create(
    languages: string[],
    namespace: string,
    key: string,
    fallbackValue: string
  ) {}
}

const fetchLabel = async (baseUrl: string, apiKey: string, keys: string) => {
  const url = new URL(baseUrl);
  url.searchParams.set("keys", keys);
  try {
    const { data } = await axios.get(url.toString(), {
      headers: {
        "X-API-Key": apiKey,
        "Access-Control-Allow-Origin": "*",
      },
    });
    return data;
  } catch (e) {
    console.error(e);
    return {};
  }
};

export default ContentApiBackend;
